var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06109 15.7495C7.46319 15.4619 6.81361 15.2961 6.15046 15.2617C4.61935 15.1904 4.33959 16.2137 4.33959 16.2137C3.03836 13.7699 5.89238 13.5087 5.89238 13.5087L6.38034 13.6447C7.42783 13.9405 8.18037 13.4116 7.69675 13.3511C7.40831 13.3144 6.62757 13.3231 6.04202 13.3339C6.58315 12.7693 7.26834 12.3619 8.02422 12.1552L0 5.63787L0 13.2303C1.36195 14.7867 10.5508 22.5 10.5508 22.5L12.7195 20.7276L18.9502 20.5809L15.6212 18.1155C18.7398 15.1753 24.604 9.61863 25.5973 8.48744L25.6667 0.5L8.06109 15.7495Z",
    fill: "#966E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0e65c311981c9a2e84a57124f48631ef.svg";
export { ForwardRef as ReactComponent };